import { createFileRoute, Link } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/sonner";
import EnhancementsPanel from "@/components/admin/EnhancementsPanel";
import EnhancePageHeroPanel from "@/components/admin/EnhancePageHeroPanel";
import { ArrowLeft } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/enhancements")({
  head: () => ({
    meta: [{ title: "Stay Enhancements CMS" }, { name: "robots", content: "noindex" }],
  }),
  component: AdminEnhancementsPage,
});

function AdminEnhancementsPage() {
  return (
    <div
      className="fixed inset-0 overflow-y-auto bg-background text-foreground"
      style={{ touchAction: "auto", overscrollBehavior: "auto" }}
    >
      <Toaster richColors closeButton position="top-right" />
      <div className="max-w-3xl mx-auto px-6 py-10 space-y-6">
        <div>
          <Link
            to="/admin"
            className="text-xs text-muted-foreground hover:text-foreground inline-flex items-center gap-1 mb-2"
          >
            <ArrowLeft className="w-3 h-3" /> Admin
          </Link>
          <h1 className="text-2xl font-serif">Stay Enhancements CMS</h1>
          <p className="text-sm text-muted-foreground mt-1">
            Manage the Stay Enhancement cards shown on the Suites and Enhance pages.
          </p>
        </div>

        <EnhancePageHeroPanel />

        <EnhancementsPanel />
      </div>
    </div>
  );
}
